import {INDENT_CONTENT_COMMAND, OUTDENT_CONTENT_COMMAND} from 'lexical';
import {IPluginHooks} from '../ToolbarPlugin/types';
import {createDispatchCommandWithoutPayload} from '../ToolbarPlugin/utils';
import {EFormatIncreaseDecrease} from '../ToolbarPlugin/enums';

export const useFormatIndent = ({editor}: IPluginHooks) => {
    const dispatchCommand = createDispatchCommandWithoutPayload(editor);

    const formatIndent = (type: EFormatIncreaseDecrease) =>
        dispatchCommand(
            type === EFormatIncreaseDecrease.INCREASE
                ? INDENT_CONTENT_COMMAND
                : OUTDENT_CONTENT_COMMAND
        );

    return {formatIndent} as const;
};
